/**
 * Funktion zur Prüfung der Geschenk-Berechtigung basierend auf dem Mindestbestellwert
 * Aktualisiert die Anzeige der Gratis-Produkte basierend auf dem Gesamtpreis
 */
/**
 * Funktion zur Validierung von Geschenkprodukten vor dem Checkout
 * Prüft, ob alle Geschenkprodukte den Mindestbestellwert erfüllen und maximal Menge 1 haben
 * @returns {Promise<boolean>} True, wenn alle Geschenkprodukte gültig sind, sonst False
 */
window.validateGiftsBeforeCheckout = function() {
  return new Promise((resolve, reject) => {
    
    // Aktuellen Warenkorb laden
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        
        // Prüfvariablen
        let allGiftsValid = true;
        const invalidGifts = [];
        const giftsToRemove = [];
        
        // Alle Produkte im Warenkorb durchgehen
        if (cart.items && Array.isArray(cart.items)) {
          cart.items.forEach((item, index) => {
            // Prüfen, ob es sich um ein Geschenkprodukt handelt
            const isGift = item.properties && (item.properties._gift === 'true' || 
                                             item.properties._free_item === 'true' || 
                                             item.properties._discount_gift === 'true');
            
            if (isGift) {
              // 1. Prüfung: Menge maximal 1
              if (item.quantity > 1) {
                allGiftsValid = false;
                invalidGifts.push({
                  title: item.title,
                  reason: 'Menge größer als 1',
                  line: index + 1
                });
                
                // Menge auf 1 reduzieren
                giftsToRemove.push({
                  id: item.id,
                  line: index + 1,
                  quantity: 1
                });
              }
              
              // 2. Prüfung: Mindestbestellwert
              if (item.properties && item.properties._gift_min_price) {
                const minPrice = parseFloat(item.properties._gift_min_price) * 100; // In Cent umrechnen
                
                // Wenn der aktuelle Gesamtpreis unter dem Mindestpreis liegt
                if (cart.total_price < minPrice) {
                  allGiftsValid = false;
                  invalidGifts.push({
                    title: item.title,
                    reason: `Mindestbestellwert von ${minPrice/100}€ nicht erreicht`,
                    line: index + 1
                  });
                  
                  // Geschenkprodukt entfernen
                  giftsToRemove.push({
                    id: item.id,
                    line: index + 1,
                    quantity: 0
                  });
                }
              }
            }
          });
        }
        
        // Wenn ungültige Geschenkprodukte gefunden wurden
        if (!allGiftsValid && giftsToRemove.length > 0) {
          
          // Flag setzen, um Endlosschleifen zu vermeiden
          window.isRemovingGifts = true;
          
          // Promises für alle zu entfernenden oder anzupassenden Geschenkprodukte erstellen
          const updatePromises = giftsToRemove.map(gift => {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                line: gift.line,
                quantity: gift.quantity
              })
            }).then(response => response.json());
          });
          
          // Alle Änderungen durchführen und dann fortfahren
          Promise.all(updatePromises)
            .then(results => {
              
              // Aktuellen Warenkorb neu laden
              return fetch('/cart.js').then(response => response.json());
            })
            .then(updatedCart => {
              // Flag zurücksetzen
              window.isRemovingGifts = false;
              
              // UI aktualisieren
              const cartUpdateEvent = new CustomEvent('cart-update', {
                detail: { cart: updatedCart }
              });
              
              // Event auslösen, um UI zu aktualisieren
              setTimeout(() => {
                window.dispatchEvent(cartUpdateEvent);
                
                // Fehlermeldung anzeigen
                alert('Einige Geschenkprodukte wurden aus Ihrem Warenkorb entfernt, da sie nicht mehr gültig sind.');
                
                // Checkout abbrechen
                resolve(false);
              }, 100);
            })
            .catch(error => {
              window.isRemovingGifts = false;
              resolve(false);
            });
        } else {
          // Alle Geschenkprodukte sind gültig
          resolve(true);
        }
      })
      .catch(error => {
        // Im Fehlerfall trotzdem fortfahren
        resolve(true);
      });
  });
};

/**
 * Funktion zur Prüfung der Geschenk-Berechtigung basierend auf dem Mindestbestellwert
 * Aktualisiert die Anzeige der Gratis-Produkte basierend auf dem Gesamtpreis
 */
window.checkGiftEligibility = function(totalPrice) {
  
  // Flag, um zu verhindern, dass die Funktion während einer Entfernung erneut aufgerufen wird
  if (window.isRemovingGifts) {
    return;
  }
  
  // Prüfen, ob automatische Geschenke vorhanden sind
  if (!window.automaticGiftsData || !Array.isArray(window.automaticGiftsData)) {
    return;
  }
  
  // Aktuellen Warenkorb laden
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      
      // Liste der bereits im Warenkorb vorhandenen Geschenkprodukte erstellen
      const existingGiftProducts = [];
      // Liste der zu entfernenden Geschenkprodukte (wenn Mindestpreis nicht mehr erreicht wird)
      const giftsToRemove = [];
      // Liste der hinzuzufügenden Geschenkprodukte (wenn berechtigt und noch nicht vorhanden)
      const itemsToAdd = [];
      // Tracke Produkt-IDs, die gleich automatisch hinzugefügt werden (zur UI-Unterdrückung)
      const pendingGiftProductIds = new Set();
      
      // Detaillierte Informationen zu jedem Produkt im Warenkorb ausgeben
      if (cart.items && Array.isArray(cart.items)) {
        
        cart.items.forEach((item, index) => {
          const isGift = item.properties && (item.properties._gift === 'true' || 
                                           item.properties._free_item === 'true' || 
                                           item.properties._discount_gift === 'true');
          
          // Wenn es sich um ein Geschenkprodukt handelt
          if (isGift) {
            // Zur Liste der existierenden Geschenkprodukte hinzufügen
            existingGiftProducts.push({
              id: item.id,
              line_index: index + 1,
              product_id: item.product_id,
              variant_id: item.variant_id,
              title: item.title,
              handle: item.handle,
              properties: item.properties
            });
            
            // Prüfen, ob das Geschenkprodukt einen Mindestpreis hat und ob dieser noch erreicht wird
            if (item.properties && item.properties._gift_min_price) {
              const minPrice = parseFloat(item.properties._gift_min_price) * 100; // In Cent umrechnen
              
              // Wenn der aktuelle Gesamtpreis unter dem Mindestpreis liegt, zur Entfernungsliste hinzufügen
              if (totalPrice < minPrice) {
                giftsToRemove.push({
                  id: item.id,
                  line: index + 1 // Shopify Cart API verwendet 1-basierte Indizes
                });
              }
            }
          }
        });
      }
      
      // Entfernen der Geschenkprodukte, die den Mindestpreis nicht mehr erreichen
      if (giftsToRemove.length > 0) {
        
        // Flag setzen, um Endlosschleifen zu vermeiden
        window.isRemovingGifts = true;
        try { console.debug('[Gifts] Removing gifts due to threshold:', giftsToRemove.map(g=>g.line)); } catch (e) {}

        // In absteigender Reihenfolge entfernen, um Line-Index-Verschiebungen zu vermeiden
        giftsToRemove.sort((a, b) => b.line - a.line);

        // Entfernen nacheinander, nicht parallel
        let chain = Promise.resolve();
        giftsToRemove.forEach(gift => {
          chain = chain.then(() => {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                line: gift.line,
                quantity: 0
              })
            }).then(response => response.json());
          });
        });

        // Nach sequentiellem Entfernen fortfahren
        return chain
          .then(() => fetch('/cart.js').then(response => response.json()))
          .then(updatedCart => {
            // Flag zurücksetzen
            window.isRemovingGifts = false;
            
            // Mit dem aktualisierten Warenkorb fortfahren
            cart = updatedCart;
            
            // Aktuellen Warenkorb neu laden und cart-update-Event auslösen
            fetch('/cart.js')
              .then(response => response.json())
              .then(freshCart => {
                const cartUpdateEvent = new CustomEvent('cart-update', {
                  detail: { cart: freshCart }
                });
                setTimeout(() => {
                  window.dispatchEvent(cartUpdateEvent);
                  try { console.debug('[Gifts] Removal complete'); } catch (e) {}
                }, 100);
              })
              .catch(error => {
                console.error('Fehler beim Aktualisieren des Warenkorbs:', error);
              });
          });
      }
      
      // Liste der Geschenkprodukte neu erstellen
      existingGiftProducts.length = 0;
      if (cart.items && Array.isArray(cart.items)) {
        cart.items.forEach((item, index) => {
          const isGift = item.properties && (item.properties._gift === 'true' || 
                                          item.properties._free_item === 'true' || 
                                          item.properties._discount_gift === 'true');
          if (isGift) {
            existingGiftProducts.push({
              product_id: item.product_id,
              variant_id: item.variant_id,
              title: item.title,
              handle: item.handle
            });
          }
        });
      }
      
      // Globales Objekt für die Geschenk-Berechtigung erstellen oder aktualisieren
      if (!window.giftEligibility) {
        window.giftEligibility = {};
      }
      
      // Globales Objekt für die Geschenk-Berechtigung erstellen oder aktualisieren
      if (!window.giftEligibility) {
        window.giftEligibility = {};
      }
  
      // Für jedes automatische Geschenk prüfen, ob es berechtigt ist
      window.automaticGiftsData.forEach(gift => {
        // Prüfen, ob der Warenkorb-Wert den Mindestbestellwert erreicht
        const isEligible = gift.free_from && totalPrice >= gift.free_from * 100;
        
        // Geschenk-Berechtigung im globalen Objekt speichern
        window.giftEligibility[gift.id] = isEligible;
        
        // Versuchen, Alpine.js-Komponente zu aktualisieren, falls verfügbar
        try {
          const cartDrawer = document.querySelector('[x-data="dsCartDrawer"]');
          if (cartDrawer) {
            const alpineComponent = Alpine.getComponent(cartDrawer);
            if (alpineComponent) {
              if (!alpineComponent.giftEligibility) {
                alpineComponent.giftEligibility = {};
              }
              alpineComponent.giftEligibility[gift.id] = isEligible;
            }
          }
        } catch (error) {
          console.warn('Alpine.js-Komponente konnte nicht aktualisiert werden:', error);
        }
    
        // Geschenk-Blöcke direkt im DOM aktualisieren
        setTimeout(() => {
          const giftBlocks = document.querySelectorAll(`[data-gift-block-id="${gift.id}"]`);
          
          giftBlocks.forEach(block => {
            // Prüfen, ob das Geschenkprodukt bereits im Warenkorb ist
            let productAlreadyInCart = false;
            const blockProductId = block.getAttribute('data-gift-product-id');
            const blockProductTitle = block.getAttribute('data-gift-product-title');
            
            if (blockProductId || blockProductTitle) {
              // Prüfen, ob ein Geschenkprodukt mit dieser ID oder diesem Titel bereits im Warenkorb ist
              productAlreadyInCart = existingGiftProducts.some(cartGift => {
                // Vergleich nach ID, wenn verfügbar
                if (blockProductId && cartGift.product_id) {
                  return blockProductId == cartGift.product_id;
                }
                // Andernfalls Vergleich nach Titel
                return blockProductTitle && cartGift.title && 
                       blockProductTitle.trim().toLowerCase() === cartGift.title.trim().toLowerCase();
              });
              
            }
            
            // Wenn das Produkt gleich automatisch hinzugefügt wird, bereits ausblenden
            const willBeAdded = blockProductId && pendingGiftProductIds.has(String(blockProductId));

            // Block nur anzeigen, wenn berechtigt UND nicht im Warenkorb UND nicht kurz vor Auto-Add
            if (isEligible && !productAlreadyInCart && !willBeAdded) {
              block.style.display = '';
              // Entferne das style-Attribut, falls es gesetzt ist
              if (block.getAttribute('style') === 'display: none;') {
                block.removeAttribute('style');
              }
            } else {
              block.style.display = 'none';
            }
          });
        }, 100); // Kurze Verzögerung, um sicherzustellen, dass der DOM aktualisiert ist
        
        // Alle Geschenkprodukte dieses Geschenks in der Konsole ausgeben
        if (gift.gifts && Array.isArray(gift.gifts)) {
          gift.gifts.forEach(giftProduct => {
            // Auto-Add: Wenn berechtigt und noch nicht im Warenkorb, zur Hinzufüge-Liste aufnehmen
            if (isEligible) {
              // Versuche, die erste Varianten-ID zu ermitteln
              let variantId = null;
              if (giftProduct && giftProduct.variants && Array.isArray(giftProduct.variants) && giftProduct.variants.length > 0) {
                variantId = giftProduct.variants[0].id;
              }
              // Falls keine Varianten-Struktur vorhanden ist, überspringen
              if (!variantId) {
                return;
              }

              // Prüfen, ob dieses Geschenk (über Variante oder Produkt) bereits als Geschenk im Cart ist
              const alreadyInCart = existingGiftProducts.some(cartGift => {
                if (cartGift.variant_id && variantId) {
                  return String(cartGift.variant_id) === String(variantId);
                }
                if (cartGift.product_id && giftProduct.id) {
                  return String(cartGift.product_id) === String(giftProduct.id);
                }
                return false;
              });

              if (!alreadyInCart) {
                // Properties für das Geschenk vorbereiten
                const properties = {
                  _gift: 'true',
                  _free: 'true',
                  _gift_block_id: gift.id
                };
                if (gift.free_from) {
                  properties._gift_min_price = gift.free_from;
                }

                itemsToAdd.push({
                  id: variantId,
                  quantity: 1,
                  properties
                });

                // Für UI direkt unterdrücken, bis Add abgeschlossen ist
                if (giftProduct && giftProduct.id) {
                  pendingGiftProductIds.add(String(giftProduct.id));
                }
              }
            }
          });
        }
      });

      // Auto-Add fehlender, berechtigter Geschenke im Batch
      // Nur ausführen, wenn aktuell keine Entfernen- oder Hinzufügen-Operation läuft
      if (itemsToAdd.length > 0) {
        // Debounce, da diese Funktion häufig getriggert wird
        if (window._autoAddGiftsTimer) {
          clearTimeout(window._autoAddGiftsTimer);
        }
        window._autoAddGiftsTimer = setTimeout(() => {
          if (window.isRemovingGifts || window.isAddingGifts) {
            return;
          }
          window.isAddingGifts = true;
          try { console.debug('[Gifts] Auto-adding gifts:', itemsToAdd.map(i=>i.id)); } catch (e) {}

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ items: itemsToAdd })
          })
          .then(() => fetch('/cart.js'))
          .then(freshCart => {
            const cartUpdateEvent = new CustomEvent('cart-update', {
              detail: { cart: freshCart }
            });
            setTimeout(() => {
              window.dispatchEvent(cartUpdateEvent);
              try { console.debug('[Gifts] Auto-add complete'); } catch (e) {}
            }, 100);
          })
          .catch((error) => {
            console.error('Fehler beim Hinzufügen der Geschenkprodukte:', error);
          })
          .finally(() => {
            window.isAddingGifts = false;
          });
        }, 150);
      }
    })
    .catch(error => console.error('Fehler beim Laden des Warenkorbs:', error));
};